/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsJswStorageManagementResource } from '@jira/router-resources__products-jsw-storage-management/src/productsJswStorageManagementResource.tsx';
import { productsJswStorageManagementRoute } from '@jira/router-routes__products-jsw-configuration-routes/src/productsJswStorageManagementRoute.tsx';
import ProductsJswStorageManagement, {
	LazyProductsJswStorageManagement,
} from './ui/products-jsw-storage-management/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const productsJswStorageManagementRouteEntry: Route = createEntry(
	productsJswStorageManagementRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.jsw-configuration.storage-management',
		// eslint-disable-next-line no-restricted-syntax
		component: ProductsJswStorageManagement,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			productsJswStorageManagementResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyProductsJswStorageManagement],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
